import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

import { IconButton, Typography } from "@mui/material";

interface Props {
  formattedWeight: string;
  onClick: () => void;
  disabled: boolean;
}

export const WeightCell = ({ formattedWeight, onClick, disabled }: Props) => {
  const handleOnClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    onClick();
  };

  return (
    <>
      <Typography variant="body1Mono">{formattedWeight}</Typography>
      {!disabled ? (
        <IconButton sx={{ padding: 0 }} onClick={handleOnClick}>
          <RemoveCircleOutlineIcon fontSize="small" />
        </IconButton>
      ) : null}
    </>
  );
};
